/**
 * 文章目录 TOC 与滚动高亮
 * 根据正文中的 h2、h3 生成分层目录，点击平滑滚动，滚动时高亮当前章节
 */
(function() {
  /** 处理文章内容内的 table：移除内联样式，保留标签结构，添加 nw-article-table 类 */
  function processArticleTables() {
    document.querySelectorAll('[id^="article-content-"]').forEach((contentEl) => {
      contentEl.querySelectorAll('table').forEach((table) => {
        [table, ...table.querySelectorAll('*')].forEach((node) => {
          if (node.removeAttribute) node.removeAttribute('style');
        });
        table.classList.add('nw-table');

        const parent = table.parentElement;
        const isWrapped =
          parent &&
          parent.tagName === 'DIV' &&
          parent.children.length === 1 &&
          parent.children[0] === table;

        if (!isWrapped) {
          const wrapper = document.createElement('div');
          wrapper.className = 'nw-table-wrapper';
          table.parentNode.insertBefore(wrapper, table);
          wrapper.appendChild(table);
        }
      });
    });
  } 

  function initArticleToc() {
    processArticleTables();

    document.querySelectorAll('[id^="article-toc-"]').forEach((tocEl) => {
      const sectionId = tocEl.id.replace('article-toc-', '');
      const contentEl = document.getElementById('article-content-' + sectionId);
      if (!contentEl || !tocEl) return;

      const showH3 = tocEl.dataset.showH3 === 'true';
      const headings = contentEl.querySelectorAll(showH3 ? 'h2, h3' : 'h2');
      if (headings.length === 0) {
        tocEl.closest('.article-toc')?.classList.add('!tw-hidden');
        return;
      }

      const slugify = (s) => s.toLowerCase().replace(/[^\w\u4e00-\u9fa5]+/g, '-').replace(/^-|-$/g, '');
      const ACTIVE_OFFSET = 120;

      headings.forEach((heading, index) => {
        const headingLevel = heading.tagName.toLowerCase();
        let id = heading.id;
        if (!id) {
          id = headingLevel + '-' + (slugify(heading.textContent.trim()) || 'section-' + (index + 1));
          heading.id = id;
        }

        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + id;
        a.className = 'article-toc__link tw-block tw-pr-2 tw-text-sm tw-border-l tw-py-2 tw-border-[#EEEEEE] tw-transition-colors';
        if (headingLevel === 'h3') {
          a.classList.add('article-toc__link--h3', 'tw-pl-6');
        } else {
          a.classList.add('tw-pl-2');
        }
        a.setAttribute('data-target-id', id);
        a.textContent = heading.textContent.trim();
        a.addEventListener('click', (e) => {
          e.preventDefault();
          document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        li.appendChild(a);
        const preferredLi = tocEl.querySelector('[data-google-preferred-toc]');
        if (preferredLi) {
          tocEl.insertBefore(li, preferredLi);
        } else {
          tocEl.appendChild(li);
        }
      });

      let activeTargetId = null;

      function keepActiveLinkVisible(link) {
        const listRect = tocEl.getBoundingClientRect();
        const linkRect = link.getBoundingClientRect();
        const scrollPadding = 8;

        if (linkRect.top < listRect.top + scrollPadding) {
          tocEl.scrollTop -= listRect.top + scrollPadding - linkRect.top;
        } else if (linkRect.bottom > listRect.bottom - scrollPadding) {
          tocEl.scrollTop += linkRect.bottom - listRect.bottom + scrollPadding;
        }
      }

      function updateActiveLink() {
        let currentHeading = null;
        for (const heading of headings) {
          const rect = heading.getBoundingClientRect();
          if (rect.top <= ACTIVE_OFFSET) currentHeading = heading;
        }
        if (!currentHeading && headings.length) currentHeading = headings[0];

        const nextActiveTargetId = currentHeading?.id || null;
        let activeLink = null;

        tocEl.querySelectorAll('.article-toc__link').forEach((link) => {
          const targetId = link.getAttribute('data-target-id');
          const isActive = targetId === nextActiveTargetId;
          link.classList.toggle('article-toc__link--active', isActive);
          if (isActive) activeLink = link;
        });

        if (activeLink && activeTargetId !== nextActiveTargetId) {
          keepActiveLinkVisible(activeLink);
        }
        activeTargetId = nextActiveTargetId;
      }

      let raf = null;
      window.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          updateActiveLink();
          raf = null;
        });
      }, { passive: true });
      updateActiveLink();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleToc);
  } else {
    initArticleToc();
  }
})();
